module.exports = __webpack_public_path__ + "media/images/emblems/Altishofen_LU-e027b3565d97f0aeb802abfc0556b2cd.png";